/* Clairvia: visitors from a country we don't deliver to see a friendly notice instead of the shop.
   The list of delivered countries comes from the store's markets (window.__cvShip), so adding a
   country in Shopify unlocks it here automatically. */
(function () {
  var d = document, ship = window.__cvShip;
  if (!ship || !ship.length || window.__cvgeo) return; window.__cvgeo = true;
  if (window.Shopify && Shopify.designMode) return;                       // never in the theme editor
  if (/bot|crawl|spider|slurp|facebookexternalhit|preview|lighthouse/i.test(navigator.userAgent)) return; // search engines & link previews still see the page
  var ss = function (k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } };
  if (ss('cvgeo-ok') === '1') return;
  var posted = /customer_posted=true/.test(location.search) && /cvgeo/.test(location.hash);

  function lang() {
    var l = (navigator.language || 'en').slice(0, 2).toLowerCase();
    return l === 'fr' || l === 'es' ? l : 'en';
  }
  var L = lang();
  var T = {
    en: { title: "We don't deliver to {c} yet", text: 'Clairvia currently ships to {list}. Leave your email and we will let you know as soon as we deliver to you.', ph: 'Your email', btn: 'Notify me', thanks: "Thank you! We'll email you as soon as Clairvia ships to {c}.", other: 'Ordering for delivery in one of these countries? Continue to the shop' },
    fr: { title: 'Nous ne livrons pas encore {c}', text: 'Pour le moment, Clairvia est livré dans ces pays : {list}. Laisse ton e-mail et on te prévient dès qu’on livre chez toi.', ph: 'Ton e-mail', btn: 'Me prévenir', thanks: 'Merci ! On t’écrit dès que Clairvia est livré {c}.', other: 'Tu commandes pour une livraison dans l’un de ces pays ? Continuer vers la boutique' },
    es: { title: 'Todavía no enviamos a {c}', text: 'Por ahora Clairvia se envía a {list}. Déjanos tu e-mail y te avisaremos en cuanto enviemos a tu país.', ph: 'Tu e-mail', btn: 'Avísame', thanks: '¡Gracias! Te escribiremos en cuanto Clairvia se envíe a {c}.', other: '¿Pides para una entrega en uno de estos países? Ir a la tienda' }
  }[L];
  function name(code) { try { return new Intl.DisplayNames([L], { type: 'region' }).of(code); } catch (e) { return code; } }
  function inCountry(code) {   // "en Allemagne / au Japon" reads better in French
    var n = name(code); if (L !== 'fr') return n;
    return (/^(Japon|Canada|Portugal|Brésil|Maroc|Danemark|Luxembourg|Mexique|Royaume-Uni|Chili|Pérou|Sénégal|Vietnam|Liban)/.test(n) ? 'au ' : /^(États-Unis|Pays-Bas|Émirats)/.test(n) ? 'aux ' : 'en ') + n;
  }
  function list() {
    var names = ship.map(name);
    if (names.length < 2) return names.join('');
    var and = { en: ' and ', fr: ' et ', es: ' y ' }[L];
    return names.slice(0, -1).join(', ') + and + names[names.length - 1];
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function show(code) {
    var c = L === 'fr' ? inCountry(code) : name(code);
    var box = d.createElement('div'); box.className = 'cvgeo'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
    box.innerHTML =
      '<div class="cvgeo__card">' +
        '<p class="cvgeo__brand">Clairvia<span>+</span></p>' +
        '<h2 class="cvgeo__title">' + esc(T.title.replace('{c}', c)) + '</h2>' +
        (posted
          ? '<p class="cvgeo__thanks">' + esc(T.thanks.replace('{c}', c)) + '</p>'
          : '<p class="cvgeo__text">' + esc(T.text.replace('{list}', list())) + '</p>' +
            '<form class="cvgeo__form" method="post" action="/contact#cvgeo" accept-charset="UTF-8">' +
              '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
              '<input type="hidden" name="contact[tags]" value="newsletter,waitlist,waitlist-' + esc(code) + '">' +
              '<input class="cvgeo__input" type="email" name="contact[email]" required autocomplete="email" placeholder="' + esc(T.ph) + '" aria-label="' + esc(T.ph) + '">' +
              '<button class="cvgeo__btn" type="submit">' + esc(T.btn) + '</button>' +
            '</form>') +
        '<button class="cvgeo__other" type="button">' + esc(T.other) + '</button>' +
      '</div>';
    d.body.appendChild(box);
    d.documentElement.classList.add('cvgeo-lock');
    box.querySelector('.cvgeo__other').addEventListener('click', function () {
      ss('cvgeo-ok', '1'); d.documentElement.classList.remove('cvgeo-lock'); box.remove();
    });
    var f = box.querySelector('.cvgeo__input'); if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 400);
  }

  function check() {
    var cached = ss('cvgeo-country');
    var decide = function (code) {
      if (!code) return;
      ss('cvgeo-country', code);
      if (ship.indexOf(code) === -1) show(code);
    };
    if (cached) return decide(cached);
    fetch('/browsing_context_suggestions.json?source=geolocation_recommendation', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { decide(j && j.detected_values && j.detected_values.country && j.detected_values.country.handle); })
      .catch(function () {});
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', check); else check();
})();
